module.exports = __webpack_public_path__ + "static/img/Bachelor_010653.0fd59a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010653.jpg
// module id = 200
// module chunks = 0